var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignalWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18262 19.5V12.2115H4.52862V19.5H2.18262ZM7.94212 19.5V9.80775H10.2884V19.5H7.94212Z",
    fill: "#F59E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7021 7.39425V19.5H16.0481V7.39425H13.7021Z",
    fill: "#A6AEBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4616 4.5V19.5H21.8079V4.5H19.4616Z",
    fill: "#A6AEBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalWarning);
export default __webpack_public_path__ + "static/media/signal_warning.2cb970d4.svg";
export { ForwardRef as ReactComponent };